// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* LAKPED-16.3 — editor de la oferta por líneas. Mismos valores que el prototipo de Paula y
   acotado a .offer-editor, que el CSS de CRA es global. */

.offer-editor {
  max-width: 1200px;
  margin: 0 auto;
  padding: 28px 32px 60px;
}

.offer-editor h1 {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 26px;
  font-weight: 600;
  margin: 0 0 4px;
  color: #1b1b1b;
}

.offer-editor-estado {
  background: #f0f0f0;
  color: #333;
  border-radius: 14px;
  padding: 3px 10px;
  font-size: 12px;
  font-weight: 400;
}

.offer-editor-sub { color: #666; font-size: 14px; margin: 0 0 20px; }

/* Los pasos hechos se pulsan para volver (LAKPED-26/27). */
.offer-editor-pasos li.hecho { padding: 0; }
.offer-editor-pasos li.hecho button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 14px 5px 6px;
  border: none;
  background: none;
  font: inherit;
  font-size: 13px;
  color: #333;
  cursor: pointer;
  border-radius: 20px;
}
.offer-editor-pasos li.hecho button:hover:not(:disabled) { background: #f2f2f2; text-decoration: underline; }
.offer-editor-pasos li.hecho button:disabled { cursor: default; color: #999; }
.offer-editor-ayuda { color: #777; font-size: 12.5px; margin: 0 0 8px; }
.offer-editor-adjunto { color: #157347; font-size: 12.5px; margin: 10px 0 0; }
/* LAKPED-26: ver el documento de origen entero desde la oferta, en el pop-up. */
.offer-editor-enlace {
  border: none;
  background: none;
  padding: 0;
  font: inherit;
  font-size: 12.5px;
  color: #157347;
  text-decoration: underline;
  cursor: pointer;
}

.offer-editor-error,
.offer-editor-ok {
  font-size: 13px;
  border-radius: 8px;
  padding: 9px 12px;
  margin: 0 0 12px;
}

.offer-editor-error { color: #5a2a00; background: #fff0e3; border-left: 4px solid #e46a00; }
.offer-editor-ok { color: #157347; background: #dff5e8; }

/* Pasos */
.offer-editor-pasos {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  list-style: none;
  margin: 0 0 20px;
  padding: 0;
}

.offer-editor-pasos li {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #888;
  background: #fff;
  border: 1px solid #e3e3e3;
  border-radius: 20px;
  padding: 5px 14px 5px 6px;
}

.offer-editor-pasos li.hecho { color: #333; }
.offer-editor-pasos li.actual { color: #1b1b1b; }

.offer-editor-paso-num {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #e5e5e5;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  color: #555;
}

.offer-editor-pasos li.actual .offer-editor-paso-num { background: #111; color: #fff; }
.offer-editor-pasos li.hecho .offer-editor-paso-num { background: #dff5e8; color: #157347; }

/* Tarjetas */
.offer-editor-tarjeta {
  background: #fff;
  border: 1px solid #e3e3e3;
  border-radius: 10px;
  padding: 18px 20px;
  margin-bottom: 16px;
}

.offer-editor-tarjeta h2 {
  font-size: 15px;
  font-weight: 600;
  margin: 0 0 12px;
  color: #1b1b1b;
}

.offer-editor-datos {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 14px;
}

.offer-editor-datos label {
  display: block;
  font-size: 12px;
  color: #666;
}

.offer-editor input,
.offer-editor textarea {
  font: inherit;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 7px 9px;
  background: #fff;
  width: 100%;
  box-sizing: border-box;
  margin-top: 4px;
}

.offer-editor textarea { resize: vertical; }

/* Tabla de líneas */
.offer-editor-tabla { width: 100%; border-collapse: collapse; }
.offer-editor-tabla th {
  text-align: left;
  font-size: 12px;
  font-weight: 600;
  color: #666;
  padding: 6px 8px;
  border-bottom: 1px solid #eee;
}
.offer-editor-tabla td { padding: 6px 8px; border-bottom: 1px solid #f4f4f4; font-size: 14px; }
.offer-editor-tabla th.der, .offer-editor-tabla td.der { text-align: right; }
.offer-editor-tabla td input { margin-top: 0; }
.offer-editor-tabla input.corto { max-width: 110px; text-align: right; }

.offer-editor-quitar {
  border: none;
  background: none;
  color: #999;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  padding: 0 4px;
}

.offer-editor-quitar:hover { color: #b71c1c; }

.offer-editor-pie-tabla {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 12px;
}

.offer-editor-total { font-size: 14px; color: #666; }
.offer-editor-total b { font-size: 17px; color: #1b1b1b; margin-left: 8px; }

/* Acciones: arriba, todas con el mismo formato y en negro (LAKPED-22). Los botones claros
   parecían etiquetas o campos de texto. */
.offer-editor-cabecera {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px 20px;
  margin-bottom: 8px;
}

.offer-editor-acciones {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}

.offer-editor-secundario,
.offer-editor-principal {
  border-radius: 8px;
  padding: 9px 16px;
  font: inherit;
  font-size: 14px;
  cursor: pointer;
}

.offer-editor-secundario { background: #fff; border: 1px solid #ccc; color: #333; }
.offer-editor-secundario:hover { border-color: #111; }
.offer-editor-principal { background: #111; border: 1px solid #111; color: #fff; }
.offer-editor-principal:hover:not(:disabled) { background: #333; }
.offer-editor-principal:disabled { opacity: 0.45; cursor: not-allowed; }
.offer-editor-aviso-guardar { width: 100%; text-align: right; font-size: 12.5px; color: #777; }


@media (max-width: 900px) {
  .offer-editor { padding: 20px 16px 40px; }
  .offer-editor-tarjeta { overflow-x: auto; }
  .offer-editor-tabla { min-width: 720px; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/OfferEditorPage.css"],"names":[],"mappings":"AAAA;0DAC0D;;AAE1D;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA,oBAAoB,WAAW,EAAE,eAAe,EAAE,gBAAgB,EAAE;;AAEpE,2DAA2D;AAC3D,+BAA+B,UAAU,EAAE;AAC3C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;AACA,2DAA2D,mBAAmB,EAAE,0BAA0B,EAAE;AAC5G,+CAA+C,eAAe,EAAE,WAAW,EAAE;AAC7E,sBAAsB,WAAW,EAAE,iBAAiB,EAAE,eAAe,EAAE;AACvE,wBAAwB,cAAc,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AAC7E,gFAAgF;AAChF;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,sBAAsB,cAAc,EAAE,mBAAmB,EAAE,8BAA8B,EAAE;AAC3F,mBAAmB,cAAc,EAAE,mBAAmB,EAAE;;AAExD,UAAU;AACV;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,+BAA+B,WAAW,EAAE;AAC5C,gCAAgC,cAAc,EAAE;;AAEhD;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,uDAAuD,gBAAgB,EAAE,WAAW,EAAE;AACtF,sDAAsD,mBAAmB,EAAE,cAAc,EAAE;;AAE3F,aAAa;AACb;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,eAAe;AACjB;;AAEA,yBAAyB,gBAAgB,EAAE;;AAE3C,oBAAoB;AACpB,sBAAsB,WAAW,EAAE,yBAAyB,EAAE;AAC9D;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,6BAA6B;AAC/B;AACA,yBAAyB,gBAAgB,EAAE,gCAAgC,EAAE,eAAe,EAAE;AAC9F,yDAAyD,iBAAiB,EAAE;AAC5E,+BAA+B,aAAa,EAAE;AAC9C,kCAAkC,gBAAgB,EAAE,iBAAiB,EAAE;;AAEvE;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA,6BAA6B,cAAc,EAAE;;AAE7C;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA,sBAAsB,eAAe,EAAE,WAAW,EAAE;AACpD,wBAAwB,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE;;AAE3E;0CAC0C;AAC1C;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,QAAQ;AACV;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA,2BAA2B,gBAAgB,EAAE,sBAAsB,EAAE,WAAW,EAAE;AAClF,iCAAiC,kBAAkB,EAAE;AACrD,0BAA0B,gBAAgB,EAAE,sBAAsB,EAAE,WAAW,EAAE;AACjF,+CAA+C,gBAAgB,EAAE;AACjE,mCAAmC,aAAa,EAAE,mBAAmB,EAAE;AACvE,8BAA8B,WAAW,EAAE,iBAAiB,EAAE,iBAAiB,EAAE,WAAW,EAAE;;;AAG9F;EACE,gBAAgB,uBAAuB,EAAE;EACzC,wBAAwB,gBAAgB,EAAE;EAC1C,sBAAsB,gBAAgB,EAAE;AAC1C","sourcesContent":["/* LAKPED-16.3 — editor de la oferta por líneas. Mismos valores que el prototipo de Paula y\n   acotado a .offer-editor, que el CSS de CRA es global. */\n\n.offer-editor {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 28px 32px 60px;\n}\n\n.offer-editor h1 {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 26px;\n  font-weight: 600;\n  margin: 0 0 4px;\n  color: #1b1b1b;\n}\n\n.offer-editor-estado {\n  background: #f0f0f0;\n  color: #333;\n  border-radius: 14px;\n  padding: 3px 10px;\n  font-size: 12px;\n  font-weight: 400;\n}\n\n.offer-editor-sub { color: #666; font-size: 14px; margin: 0 0 20px; }\n\n/* Los pasos hechos se pulsan para volver (LAKPED-26/27). */\n.offer-editor-pasos li.hecho { padding: 0; }\n.offer-editor-pasos li.hecho button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 5px 14px 5px 6px;\n  border: none;\n  background: none;\n  font: inherit;\n  font-size: 13px;\n  color: #333;\n  cursor: pointer;\n  border-radius: 20px;\n}\n.offer-editor-pasos li.hecho button:hover:not(:disabled) { background: #f2f2f2; text-decoration: underline; }\n.offer-editor-pasos li.hecho button:disabled { cursor: default; color: #999; }\n.offer-editor-ayuda { color: #777; font-size: 12.5px; margin: 0 0 8px; }\n.offer-editor-adjunto { color: #157347; font-size: 12.5px; margin: 10px 0 0; }\n/* LAKPED-26: ver el documento de origen entero desde la oferta, en el pop-up. */\n.offer-editor-enlace {\n  border: none;\n  background: none;\n  padding: 0;\n  font: inherit;\n  font-size: 12.5px;\n  color: #157347;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.offer-editor-error,\n.offer-editor-ok {\n  font-size: 13px;\n  border-radius: 8px;\n  padding: 9px 12px;\n  margin: 0 0 12px;\n}\n\n.offer-editor-error { color: #5a2a00; background: #fff0e3; border-left: 4px solid #e46a00; }\n.offer-editor-ok { color: #157347; background: #dff5e8; }\n\n/* Pasos */\n.offer-editor-pasos {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  list-style: none;\n  margin: 0 0 20px;\n  padding: 0;\n}\n\n.offer-editor-pasos li {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: #888;\n  background: #fff;\n  border: 1px solid #e3e3e3;\n  border-radius: 20px;\n  padding: 5px 14px 5px 6px;\n}\n\n.offer-editor-pasos li.hecho { color: #333; }\n.offer-editor-pasos li.actual { color: #1b1b1b; }\n\n.offer-editor-paso-num {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: #e5e5e5;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 600;\n  color: #555;\n}\n\n.offer-editor-pasos li.actual .offer-editor-paso-num { background: #111; color: #fff; }\n.offer-editor-pasos li.hecho .offer-editor-paso-num { background: #dff5e8; color: #157347; }\n\n/* Tarjetas */\n.offer-editor-tarjeta {\n  background: #fff;\n  border: 1px solid #e3e3e3;\n  border-radius: 10px;\n  padding: 18px 20px;\n  margin-bottom: 16px;\n}\n\n.offer-editor-tarjeta h2 {\n  font-size: 15px;\n  font-weight: 600;\n  margin: 0 0 12px;\n  color: #1b1b1b;\n}\n\n.offer-editor-datos {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 14px;\n}\n\n.offer-editor-datos label {\n  display: block;\n  font-size: 12px;\n  color: #666;\n}\n\n.offer-editor input,\n.offer-editor textarea {\n  font: inherit;\n  font-size: 14px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  padding: 7px 9px;\n  background: #fff;\n  width: 100%;\n  box-sizing: border-box;\n  margin-top: 4px;\n}\n\n.offer-editor textarea { resize: vertical; }\n\n/* Tabla de líneas */\n.offer-editor-tabla { width: 100%; border-collapse: collapse; }\n.offer-editor-tabla th {\n  text-align: left;\n  font-size: 12px;\n  font-weight: 600;\n  color: #666;\n  padding: 6px 8px;\n  border-bottom: 1px solid #eee;\n}\n.offer-editor-tabla td { padding: 6px 8px; border-bottom: 1px solid #f4f4f4; font-size: 14px; }\n.offer-editor-tabla th.der, .offer-editor-tabla td.der { text-align: right; }\n.offer-editor-tabla td input { margin-top: 0; }\n.offer-editor-tabla input.corto { max-width: 110px; text-align: right; }\n\n.offer-editor-quitar {\n  border: none;\n  background: none;\n  color: #999;\n  font-size: 18px;\n  line-height: 1;\n  cursor: pointer;\n  padding: 0 4px;\n}\n\n.offer-editor-quitar:hover { color: #b71c1c; }\n\n.offer-editor-pie-tabla {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-top: 12px;\n}\n\n.offer-editor-total { font-size: 14px; color: #666; }\n.offer-editor-total b { font-size: 17px; color: #1b1b1b; margin-left: 8px; }\n\n/* Acciones: arriba, todas con el mismo formato y en negro (LAKPED-22). Los botones claros\n   parecían etiquetas o campos de texto. */\n.offer-editor-cabecera {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px 20px;\n  margin-bottom: 8px;\n}\n\n.offer-editor-acciones {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.offer-editor-secundario,\n.offer-editor-principal {\n  border-radius: 8px;\n  padding: 9px 16px;\n  font: inherit;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.offer-editor-secundario { background: #fff; border: 1px solid #ccc; color: #333; }\n.offer-editor-secundario:hover { border-color: #111; }\n.offer-editor-principal { background: #111; border: 1px solid #111; color: #fff; }\n.offer-editor-principal:hover:not(:disabled) { background: #333; }\n.offer-editor-principal:disabled { opacity: 0.45; cursor: not-allowed; }\n.offer-editor-aviso-guardar { width: 100%; text-align: right; font-size: 12.5px; color: #777; }\n\n\n@media (max-width: 900px) {\n  .offer-editor { padding: 20px 16px 40px; }\n  .offer-editor-tarjeta { overflow-x: auto; }\n  .offer-editor-tabla { min-width: 720px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
